import { config } from './config';
import { bootstrap } from './bootstrap';
import { services } from './services';

export default {
  config,
  bootstrap,
  services,
};
